// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';
import { DisclaimerTooltip } from '../tooltips';
import ComparisonItem from '@/types/comparison-item';

type Props = {
  value?: any;
  className?: string;
  onClick?: () => void;
  id?: string;
  disclaimer?: string;
  item?: ComparisonItem;
};

const RiskRatingCell: React.FunctionComponent<Props> = ({ value, className, onClick, id, disclaimer, item }: Props) => {
  if (value == null) {
    return <NoDataCell onClick={onClick} id={id} />;
  }

  const disclaimerInfo = item && disclaimer ? item.disclaimers?.[disclaimer] : undefined;

  return (
    <div className={classNames(className, 'cell risk-rating-cell')} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">
        <span>{value}</span>

        {disclaimerInfo && <DisclaimerTooltip disclaimer={disclaimerInfo} />}
      </span>
    </div>
  );
};

export default RiskRatingCell;
